const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  // 查询无税则品名
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/tp-hscode-cca/search-jynames-aos', {params})
  },
  // 创建清关行品名税则
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/tp-hscode-cca/create-jynames-aos', params)
  },
  // 批量创建清关行品名税则
  batchCreate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/tp-hscode-cca/batch-create', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tpHscodeCca.js